import { StorefrontModule } from '@vue-storefront/core/lib/modules'
import { StorageManager } from '@vue-storefront/core/lib/storage-manager'
import { module } from './store'
import { afterRegistration } from './hooks/afterRegistration'
import { beforeRegistration } from './hooks/beforeRegistration'
import { MARKETING_CONSENT, whenConsented } from 'src/modules/gdpr-cookie-setup/helpers'

export const KEY = 'klaviyo'

export const defaultEventsConfig = {
  'productViewed': ['product-after-single'],
  'productAddedToCart': ['cart-before-add'],
  'productRemovedFromCart': [
    {
      'before': 'cart-before-delete',
      'after': 'cart-after-delete'
    }
  ],
  'checkoutStarted': ['checkout-after-mounted'],
  'orderPlaced': ['order-after-placed']
}

/**
 * @param {Object} context
 * @return {void}
 */
export const KlaviyoModule: StorefrontModule = function ({ store, appConfig, router }) {
  StorageManager.init(KEY)
  store.registerModule(KEY, module)

  whenConsented(MARKETING_CONSENT, () => {
    beforeRegistration(appConfig, store)
    afterRegistration(appConfig, store, router)
  })
}
